<template>
    <section>
        <section class="overlay"/>
        <section class="m--wrapper n--flex--center">
            <section class="t--space--f">
                <router-link class="top--text" to="/select-date">
                    <i class="fas fa-chevron-left"/>
                    <span>terug</span>
                </router-link>
                <h1 class="title-r--h1">
                    Tijd om wat liederen toe te voegen.
                </h1>
                <div>
                    <input @input="searchSongs()" v-model="searchSong"
                           autocomplete="off"
                           class="field--input--search bxs-m"
                           name="search_item" placeholder="Zoek een lied.."
                           type="text"
                    >
                </div>
            </section>
            <section class="results">
                <ul class="ma-bot-e" id="songs">
                    <li class="song--item" v-if="!songs">
                        Er zijn helaas geen resultaten gevonden...
                    </li>
                    <li v-for="(song, index) of filteredSongs"
                        v-bind:key="index"
                        @click="selectSong(song)"
                        v-else
                        class="song--item"
                        :class=" { selected: $store.state.service.selectedSongs.find( searchedSong => { return searchedSong.name === song.name; })}"
                    >
                        <span v-html="song.name"></span>
                        <div class="s--a">
                            <span class="song--type">{{ getSongType(song.type) }}</span>
                            <button class="add--button">
                                <i
                                        class="fas fa-plus-circle fa-2x"
                                        style="color: #4A5FFC"
                                        v-if="
                    !$store.state.service.selectedSongs.find(searchedSong => {
                      return searchedSong.name === song.name;
                    })
                  "
                                />
                                <i class="fas fa-check fa-2x" style="color: #51e64c" v-else/>
                            </button>
                        </div>
                    </li>
                </ul>
            </section>
        </section>
        <section class="search--footer">
            <section @click="clickMenu()" class="flex--space--footer">
                <div class="footer--wrap m--wrapper flex--space--footer">
                    <div class="count--number">
                        {{ $store.state.service.selectedSongs.length }}
                    </div>
                    <h4 class="title--h4 white--color">Liederen</h4>
                    <div id="menu_button">
                        <i class="fas fa-chevron-up fa-2x icon" id="menu_butt" style="color: white"/>
                    </div>
                </div>
            </section>
            <section class="m--wrapper h--flex--space" id="results--songs">
                <h4 v-if="$store.state.service.selectedSongs.length < 1" class="songs_msg title--h4">
                    Je moet eerst liederen toevoegen om verder te kunnen gaan.
                </h4>
                <ul class="song--list" v-else>
                    <draggable ghost-class="ghost" handle=".drag" v-model="$store.state.service.selectedSongs">
                        <li v-bind:key="song['.key']" v-for="song in $store.state.service.selectedSongs" class="song--item" >
                            {{ song.name }}
                            <div class="s--a">
                                <i class="drag fas fa-grip-lines fa-2x"/>
                                <i @click="selectSong(song)" class="fas fa-trash-alt fa-2x" style="color: red"/>
                            </div>
                        </li>
                    </draggable>
                </ul>
            </section>
            <router-link to="/service" v-if="$store.state.service.selectedSongs.length > 0" class=" bgc--p--button h--flex--center c--flex--center" id="c-ss">
                Maak zangdienstlijst
            </router-link>
        </section>
    </section>
</template>

<script>
import { gsap } from 'gsap'
import draggable from 'vuedraggable'

const axios = require('axios')
let gsapTimeline = gsap.timeline()

export default {
  name: 'selectSong',
  components: {
    draggable
  },
  data () {
    return {
      searchSong: '',
      songs: [],
      filteredSongs: [],
      toggledFooter: false,
      loading: true,
      error: false
    }
  },
  mounted () {
    if (!this.$store.state.selectDateStep.dateReady) {
      this.$router.push('/')
    }
  },
  methods: {
    // Finish empty search bar after typing song or chprd
    // emptySearchBar () {
    //   this.searchSong = ''
    // },
    getSongs () {
      const path = 'https://dedeur.dev/api/songs'
      axios.get(path)
        .then((res) => {
          this.songs = res.data
          if (this.searchSong === '') {
            this.filteredSongs = res.data
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        })
    },
    getSongType (songType) {
      if (songType === 'fast') {
        return 'S'
      } else if (songType === 'slow') {
        return 'L'
      } else {
        return '-'
      }
    },
    selectSong (selectedSong) {
      let filteredSong = this.$store.state.service.selectedSongs.find(song => {
        return selectedSong.name === song.name
      })

      if (!filteredSong) {
        this.$store.commit('selectStoreSong', {
          song: selectedSong
        })
      } else {
        this.$store.commit('deselectStoreSong', {
          song: selectedSong
        })
      }
    },
    searchSongs () {
      if (this.searchSong === '') {
        this.filteredSongs = this.songs
      } else {
        let options = {
          threshold: 0.1,
          location: 8,
          distance: 100,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: [
            {
              name: 'name',
              weight: 0.3
            },
            {
              name: 'chord',
              weight: 0.7
            }
          ]
        }

        this.$search(this.searchSong, this.songs, options).then(results => {
          this.filteredSongs = results
        })
      }

      let x = this.songs.length
      let mbottom = x / 4 + 64

      gsapTimeline.to('#results', {
        marginBottom: mbottom,
        ease: 'power2.inOut',
        duration: '0.32'
      })
    },
    clickMenu () {
      this.toggledFooter = !this.toggledFooter

      if (this.toggledFooter) {
        gsapTimeline.to('#results--songs', {
          height: '70vh',
          ease: 'power2.inOut',
          duration: '0.32'
        })
        gsapTimeline.to(
          '#menu_butt',
          {
            scale: 0.9,
            rotate: '180deg',
            ease: 'power2.inOut',
            duration: '0.42'
          },
          '-=0.23'
        )
        gsapTimeline.to(
          '.overlay',
          {
            zIndex: 2,
            duration: '0.01'
          },
          '-=0.23'
        )
        gsapTimeline.to(
          '.overlay',
          {
            opacity: 0.8,
            ease: 'power2.inOut',
            duration: '0.32'
          },
          '-=0.23'
        )
        gsapTimeline.to('body', {
          overflow: 'hidden',
          duration: '0.1'
        })
        gsapTimeline.to(
          '#c-ss',
          {
            bottom: 0,
            opacity: 1,
            ease: 'power2.inOut',
            duration: '0.32'
          },
          '-=0.23'
        )
      } else {
        gsapTimeline.to('#results--songs', {
          height: '0vh',
          ease: 'power2.inOut',
          duration: '0.32'
        })
        gsapTimeline.to(
          '#c-ss',
          {
            bottom: -60,
            opacity: 1,
            ease: 'power2.inOut',
            duration: '0.32'
          },
          '-=0.23'
        )
        gsapTimeline.to(
          '#menu_butt',
          {
            scale: 0.9,
            rotate: '0deg',
            ease: 'power2.inOut',
            duration: '0.42'
          },
          '-=0.23'
        )
        gsapTimeline.to(
          '.overlay',
          {
            opacity: 0,
            ease: 'power2.inOut',
            duration: '0.32'
          },
          '-=0.63'
        )
        gsapTimeline.to('.overlay', {
          zIndex: -1,
          ease: 'power2.inOut'
        })
        gsapTimeline.to('body', {
          overflow: 'visible',
          duration: '0.1'
        })
      }
    }
  },
  created () {
    this.getSongs()
  }
}
</script>
